import { Sparkles, Gauge, ArrowRight } from 'lucide-react';

const DEFAULT_COPY = {
  title: 'Start veilig met meten',
  subtext:
    'Meten is vaak verstandiger dan direct een batterij of dure installatie kopen. ' +
    'Powersure helpt bepalen welke meetstap bij uw woning past — zonder gegevensdeling zonder vervolgstap.',
  bullets: [
    'Eerst live inzicht in verbruik, teruglevering en pieken',
    'Daarna bepalen welke verbruiker écht de meeste kans geeft',
    'Pas uitbreiden als de metingen laten zien dat het nut heeft',
  ],
  cta_primary: 'Controleer mijn startpakket',
  cta_secondary: 'Bekijk mogelijke vervolgstappen',
};

export default function StarterKitSummary({ copy, onPrimary, onSecondary }) {
  const c = { ...DEFAULT_COPY, ...(copy || {}) };
  // Keep the field name `bullets` forward-compatible with older API shapes
  const bullets = c.bullets || DEFAULT_COPY.bullets;

  return (
    <div
      className="bg-emerald-50 border border-emerald-200 rounded-2xl p-5 sm:p-7"
      data-testid="ec-sk-summary"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
          <Gauge className="w-5 h-5 text-emerald-700" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] uppercase tracking-wider font-semibold text-emerald-700">
            Uw veilige eerste stap
          </div>
          <h1
            className="text-[22px] sm:text-[26px] leading-tight font-medium text-primary mt-1.5"
            style={{ fontFamily: 'Outfit' }}
            data-testid="ec-sk-summary-title"
          >
            {c.title}
          </h1>
        </div>
      </div>

      {c.subtext && (
        <p
          className="mt-4 text-[15px] sm:text-base leading-relaxed text-emerald-900/90"
          data-testid="ec-sk-summary-subtext"
        >
          {c.subtext}
        </p>
      )}

      <ul className="mt-5 space-y-2.5" data-testid="ec-sk-summary-bullets">
        {bullets.map((b, i) => (
          <li
            key={i}
            className="flex items-start gap-3 text-[15px] sm:text-base leading-relaxed text-foreground"
          >
            <span className="w-6 h-6 rounded-full bg-white text-emerald-700 flex items-center justify-center text-[13px] font-bold flex-shrink-0 mt-0.5 border border-emerald-300">
              {i + 1}
            </span>
            <span>{b}</span>
          </li>
        ))}
      </ul>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        <button
          onClick={onPrimary}
          className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-[15px] font-semibold"
          data-testid="ec-sk-summary-cta-primary"
        >
          <Sparkles className="w-4 h-4" />
          {c.cta_primary}
        </button>
        <button
          onClick={onSecondary}
          className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-[15px] font-semibold border-2 border-emerald-300 text-emerald-800 bg-white hover:bg-emerald-50"
          data-testid="ec-sk-summary-cta-secondary"
        >
          {c.cta_secondary}
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
